import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-thank-you-page',
  templateUrl: './thank-you-page.component.html',
  styleUrls: ['./thank-you-page.component.css']
})
export class ThankYouPageComponent implements OnInit {
  @Input() brandName;
  @Input() subscriptionFlag;
  constructor() { }

  ngOnInit() {
  }
}
